import {
    AGENDA_LIST,
    AGENDA_FULLLIST,
    AGENDA_FILTER,
    AGENDA_CREATE,
    AGENDA_UPDATE,
    AGENDA_DELETE,
    AGENDA_UPDATE_SUCCESS,
    AGENDA_DELETE_SUCCESS,
  
    AGENDA_CREATE_SUCCESS,
    AGENDA_LIST_SUCCESS,
    AGENDA_FULLLIST_SUCCESS,
    AGENDA_REQUEST_FAILED,
  } from "../agenda/actionTypes";
  
  export const agendaList = () => {
    return {
      type: AGENDA_LIST,
      payload: {},
    };
  };
  export const agendaFulllist = () => {
    return {
      type: AGENDA_FULLLIST,
      payload: {},
    };
  };
  
  export const agendaCreate = (agenda) => {
    return {
      type: AGENDA_CREATE,
      payload: agenda,
    };
  };
  
  export const agendaFilter = (changeUrl) => {
    return {
      type: AGENDA_FILTER,
      payload: { changeUrl },
    };
  };
  
  export const agendaUpdate = (id, data) => {
    return {
      type: AGENDA_UPDATE,
      payload: { id, data },
    };
  };
  export const agendaDelete = (id) => {
    return {
      type: AGENDA_DELETE,
      payload: { id },
    };
  };
  
  export const agendaListSuccess = (agenda) => {
    return {
      type: AGENDA_LIST_SUCCESS,
      payload: agenda,
    };
  };
  export const agendaFuLLListSuccess = (agenda) => {
    return {
      type: AGENDA_FULLLIST_SUCCESS,
      payload: agenda,
    };
  };
  
  export const agendaCreateSuccess = (agendaCreated) => {
    return {
      type: AGENDA_CREATE_SUCCESS,
      payload: agendaCreated,
    };
  };
  
  export const agendaUpdateSuccess = (agendaUpdated) => {
    return {
      type: AGENDA_UPDATE_SUCCESS,
      payload: agendaUpdated,
    };
  };
  
  export const agendaDeleteSuccess = (agendaDeleted) => {
    return {
      type: AGENDA_DELETE_SUCCESS,
      payload: agendaDeleted,
    };
  };
  
  export const agendaRequestFailed = (error) => {
    return {
      type: AGENDA_REQUEST_FAILED,
      payload: error,
    };
  };
  